/**
 * Format a date string as DD.MM.YYYY with zero-padded day and month.
 * Uses Europe/Warsaw timezone to avoid off-by-one day shifts for Polish users.
 */
export function formatDateDDMMYYYY(dateStr?: string): string {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  if (isNaN(d.getTime())) return ''
  const formatter = new Intl.DateTimeFormat('pl-PL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'Europe/Warsaw',
  })
  return formatter.format(d)
}
